import React from 'react'
import { synchroCase } from '@vt/apis/lib-ex/v2/givrali'
import { useAppEx, useTbViewStore } from '@vt/hooks'
import { Toast } from '@ow/comps'
import { pick } from 'lodash-es'

const SynchroCase = function ({ children }) {
  const { appId } = useAppEx()
  const { tbId } = useTbViewStore((state) => pick(state, ['tbId']))

  const clickhandle = () => {
    synchroCase(appId, tbId, new Date().valueOf()).then((res) => {
      Toast.success({
        title: res.message,
      })
    })
  }
  return <div onClick={clickhandle}>{children}</div>
}

export default SynchroCase
